import { lazyPage } from '../../utils/lazyPage';

// Hub pages
export const LearnHub = lazyPage(() => import('./LearnHub'));
export const QuickStartHub = lazyPage(() => import('./quick-start/QuickStartHub'));
export const StrategiesHub = lazyPage(() => import('./strategies/StrategiesHub'));
export const GuidesHub = lazyPage(() => import('./guides/GuidesHub'));
export const SportsHub = lazyPage(() => import('./sports/SportsHub'));
export const GlossaryHub = lazyPage(() => import('./glossary/GlossaryHub'));
export const StatesHub = lazyPage(() => import('./states/StatesHub'));

// Main articles
export const BeginnersGuideEvBetting = lazyPage(() => import('./beginners-guide-ev-betting'));

// Quick Start
export const WhatIsExpectedEv = lazyPage(() => import('./quick-start/what-is-expected-ev'));
export const CalculateEvLikePro = lazyPage(() => import('./quick-start/calculate-ev-like-pro'));
export const AvoidEvMissteps = lazyPage(() => import('./quick-start/avoid-ev-missteps'));
export const MoneylineBettingGuide = lazyPage(() => import('./quick-start/moneyline-betting-guide'));
export const PointSpreadBettingGuide = lazyPage(() => import('./quick-start/point-spread-betting-guide'));
export const TotalOverUnderBettingGuide = lazyPage(() => import('./quick-start/total-over-under-betting-guide'));
export const WhatIsVigJuice = lazyPage(() => import('./quick-start/what-is-vig-juice'));
export const HowMuchBankrollSportsBetting = lazyPage(() => import('./quick-start/how-much-bankroll-sports-betting'));
export const PushInBetting = lazyPage(() => import('./quick-start/push-in-betting'));
export const TeaserBets = lazyPage(() => import('./quick-start/teaser-bets'));
export const LiveBetting = lazyPage(() => import('./quick-start/live-betting'));
export const FuturesBetting = lazyPage(() => import('./quick-start/futures-betting'));
export const SameGameParlay = lazyPage(() => import('./quick-start/same-game-parlay'));
export const ArbitrageBetting = lazyPage(() => import('./quick-start/arbitrage-betting'));
export const HowBettingOddsWork = lazyPage(() => import('./quick-start/how-betting-odds-work'));
export const WhatDoesPlusTwoHundredMean = lazyPage(() => import('./quick-start/what-does-plus-200-mean'));
export const HowToReadBettingLines = lazyPage(() => import('./quick-start/how-to-read-betting-lines'));
export const CashOutBetting = lazyPage(() => import('./quick-start/cash-out-betting'));
export const OddsBoosts = lazyPage(() => import('./quick-start/odds-boosts'));
export const CompareSportsbookOdds = lazyPage(() => import('./quick-start/compare-sportsbook-odds'));
export const KeyNumbersNFL = lazyPage(() => import('./quick-start/key-numbers-nfl'));

// Strategies
export const DataSciencePowersEvBets = lazyPage(() => import('./strategies/data-science-powers-ev-bets'));
export const ModelsFindHiddenValue = lazyPage(() => import('./strategies/models-find-hidden-value'));
export const SpotMispricedOddsAnalytics = lazyPage(() => import('./strategies/spot-mispriced-odds-analytics'));
export const BankrollManagement = lazyPage(() => import('./strategies/bankroll-management'));
export const BankrollMistakesToAvoid = lazyPage(() => import('./strategies/bankroll-mistakes-avoid'));
export const KellyCriterion = lazyPage(() => import('./strategies/kelly-criterion'));
export const AvoidGettingLimitedSportsbooks = lazyPage(() => import('./strategies/avoid-getting-limited-sportsbooks'));
export const BuildBettingModel = lazyPage(() => import('./strategies/build-betting-model'));
export const HomeFieldAdvantage = lazyPage(() => import('./strategies/home-field-advantage'));
export const BuyingPointsStrategy = lazyPage(() => import('./strategies/buying-points-strategy'));
export const AlternateLinesStrategy = lazyPage(() => import('./strategies/alternate-lines-strategy'));
// Graduating Bettor decision page (GH #138)
export const MultiBookBankrollRules = lazyPage(() => import('./strategies/multi-book-bankroll-rules'));

// Sports guides
export const NFLBettingGuide = lazyPage(() => import('./sports/nfl'));
export const CollegeFootballBettingGuide = lazyPage(() => import('./sports/college-football'));
export const MLBBettingGuide = lazyPage(() => import('./sports/mlb'));
export const NHLBettingGuide = lazyPage(() => import('./sports/nhl'));
export const NBABettingGuide = lazyPage(() => import('./sports/nba'));
export const WNBABettingGuide = lazyPage(() => import('./sports/wnba'));
export const CollegeBasketballBettingGuide = lazyPage(() => import('./sports/mens-college-basketball'));

// Comparisons
export const PlusEVBetsVsOddsJam = lazyPage(() => import('./comparisons/plusevbets-vs-oddsjam'));
export const OddsJamAlternative = lazyPage(() => import('./comparisons/oddsjam-alternative'));
export const RotoWireAlternative = lazyPage(() => import('./comparisons/rotowire-alternative'));
export const OutlierVsPlusEVBets = lazyPage(() => import('./comparisons/outlier-vs-plusevbets'));
export const PlusEVBetsVsPikkit = lazyPage(() => import('./comparisons/plusevbets-vs-pikkit'));
export const PlusEVBetsVsBettingPros = lazyPage(() => import('./comparisons/plusevbets-vs-bettingpros'));
export const PlusEVBetsVsUnabated = lazyPage(() => import('./comparisons/plusevbets-vs-unabated'));
export const PlusEVBetsVsBetQL = lazyPage(() => import('./comparisons/plusevbets-vs-betql'));
export const PlusEVBetsVsActionNetwork = lazyPage(() => import('./comparisons/plusevbets-vs-action-network'));
export const PlusEVBetsVsSharpApp = lazyPage(() => import('./comparisons/plusevbets-vs-sharp-app'));

// Guides
export const CanYouMakeMoneySportsBetting = lazyPage(() => import('./guides/can-you-make-money-sports-betting'));
export const BestEVBettingTools2026 = lazyPage(() => import('./guides/best-ev-betting-tools-2026'));
export const WhyMostEvBetsLose = lazyPage(() => import('./guides/why-most-ev-bets-lose'));
export const WhyDoIKeepLosing = lazyPage(() => import('./guides/why-do-i-keep-losing'));
export const ParlaysVsStraightBets = lazyPage(() => import('./guides/parlays-vs-straight-bets'));
export const FanDuelVsDraftKingsOdds = lazyPage(() => import('./guides/fanduel-vs-draftkings-odds'));
export const TrackYourBets = lazyPage(() => import('./guides/track-your-bets'));
export const ClosingLineValueExplained = lazyPage(() => import('./guides/closing-line-value-explained'));
export const WhenToBetEarlyVsLate = lazyPage(() => import('./guides/when-to-bet-early-vs-late'));
export const HowToResearchBets = lazyPage(() => import('./guides/how-to-research-bets'));
export const WhyParlaysAlwaysLose = lazyPage(() => import('./guides/why-parlays-always-lose'));
export const MoneylineVsSpread = lazyPage(() => import('./guides/moneyline-vs-spread'));
export const PropsVsGameBets = lazyPage(() => import('./guides/props-vs-game-bets'));
// Graduating Bettor decision pages (GH #136, #137, #139)
export const CfbMoneylineVsSpreadBigFavorites = lazyPage(() => import('./guides/cfb-moneyline-vs-spread-big-favorites'));
export const SaturdayClvWorkflow = lazyPage(() => import('./guides/saturday-clv-workflow'));
export const NcaafVsNflMarketDifferences = lazyPage(() => import('./guides/ncaaf-vs-nfl-market-differences'));
export const HowToBetOnNFL = lazyPage(() => import('./guides/how-to-bet-on-nfl'));
export const HowToBetOnNBA = lazyPage(() => import('./guides/how-to-bet-on-nba'));
export const HowToBetOnWNBA = lazyPage(() => import('./guides/how-to-bet-on-wnba'));
export const HowToBetOnMLB = lazyPage(() => import('./guides/how-to-bet-on-mlb'));
export const HowToBetOnNHL = lazyPage(() => import('./guides/how-to-bet-on-nhl'));
export const HowToBetOnCollegeFootball = lazyPage(() => import('./guides/how-to-bet-on-college-football'));
export const HowToBetOnCollegeBasketball = lazyPage(() => import('./guides/how-to-bet-on-college-basketball'));

